
import { booleanProp } from '@/mixins'
import { defineComponent, ref, watch } from 'vue'
export default defineComponent({
  name: 'FrAlert',
  props: {
    type: {
      type: String,
      default: () => 'success'
    },
    showDismiss: booleanProp(false),
    modelValue: booleanProp(false)
  },
  emits: ['update:modelValue', 'onClose'],
  setup(props, { emit }) {
    const open = ref(props.modelValue)
    // if model value updated emit
    const handlelOnClose = () => {
      emit('onClose', true)
    }
    watch(
      () => props.modelValue,
      (from: boolean, to: boolean) => {
        // // console.log('cambio', from, to)
        open.value = props.modelValue
      }
    )

    return {
      open,
      handlelOnClose
    }
  }
})
